import React, { Component } from "react";
import { Wrapper, Row } from "app/NativeComponents/common";
import { store } from "app/store";
import EngineTab from "./EngineTab";
import EnginePlans from "./EnginePlans";

import { loadEngines } from "app/NativeActions";

class Engines extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_engine: props.selected_engine || "driving",
      engines: []
    };
  }

  componentDidMount() {
    loadEngines()
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState(() => ({ engines: data.items }));
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  componentDidUpdate(prevProps) {
    if (this.props.selected_engine !== prevProps.selected_engine) {
      this.setState({
        selected_engine: this.props.selected_engine
      });
    }
  }

  render() {
    const { selected_engine, engines } = this.state;
    const colors = store.getState().settings.colors;
    const isMobile = store.getState().native.isMobile;

    return (
      <Wrapper
        style={{
          alignSelf: "stretch",
          alignItems: "center",
          justifyContent: "flex-start",
          flex: 1
        }}
      >
        <Row>
          {engines &&
            engines.map((engine, i) => {
              if (engine.fields.display) {
                return (
                  <EngineTab
                    key={"engine_" + i}
                    onPress={() => {
                      this.setState({ selected_engine: engine.fields.slug });
                      if (this.props.selectEngineTab) {
                        this.props.selectEngineTab(engine.fields.slug);
                      }
                    }}
                    title={
                      isMobile
                        ? engine.fields.tabTitleMobile
                        : engine.fields.tabTitle
                    }
                    active={selected_engine == engine.fields.slug}
                    colors={colors}
                    flag_title={engine.fields.tabExtra}
                  />
                );
              }
              return null;
            })}
        </Row>
        <Wrapper
          style={{
            alignSelf: "stretch",
            flex: 1,
            padding: 40,
            backgroundColor: colors.card_color
          }}
        >
          <EnginePlans
            onEngineSelect={this.props.onEngineSelect}
            include_copy={true}
            engine_slug={selected_engine}
            include_annual_toggle={this.props.include_annual_toggle}
            onFrequencySwitch={this.props.onFrequencySwitch}
            selected_frequency={this.props.selected_frequency}
            onDemoPress={this.props.onDemoPress}
          />
        </Wrapper>
      </Wrapper>
    );
  }
}

export default Engines;
